<p-dialog header="Equipment Summary" [(visible)]="showEquipmentPopUp" [position]="'top'" [draggable]="false"
    [resizable]="false" [breakpoints]="{'960px': '75vw'}" [style]="{width: '60vw'}" [baseZIndex]="10000" modal="true" (onShow)="onShow()"
    (onHide)="onHide()" dismissableMask="true">
    <div class="row">
        <div class="col-md-12 col-lg-12">
            <div class="table-section">
                <p-table #dTable [value]="lstEquipmentDetails" class="eq_summary_table no-bottom-border">
                    <ng-template pTemplate="header">
                        <tr>
                            <th pSortableColumn="equipmentType">Equipment Type <p-sortIcon field="equipmentType"></p-sortIcon></th>
                            <th pSortableColumn="total">Total Equipment <p-sortIcon field="total"></p-sortIcon></th>
                            <th pSortableColumn="available">Active Equipment <p-sortIcon field="available"></p-sortIcon></th>
                            <th pSortableColumn="underMaintenance">Under Maintenance <p-sortIcon field="underMaintenance"></p-sortIcon></th>
                            <th pSortableColumn="underBreakdown">Under Breakdown <p-sortIcon field="underBreakdown"></p-sortIcon></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-row let-i="rowIndex">
                        <tr>
                            <td>{{row.equipmentType}}</td>
                            <td>{{row.total}}</td>
                            <td>{{row.available}}</td>
                            <td>{{row.underMaintenance}}</td>
                            <td>{{row.underBreakdown}}</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                            <td [attr.colspan]="5">
                                <span class="no_data_theme">No records found!</span>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
</p-dialog>